// extracted by mini-css-extract-plugin
export var blue = "bs_dq";
export var dark = "bs_cD";
export var gold = "bs_dr";
export var gray = "bs_ds";
export var iconMain = "bs_dx";
export var light = "bs_cB";
export var magenta = "bs_dw";
export var none = "bs_dt";
export var orange = "bs_dv";
export var original = "bs_dp";
export var root = "bs_dn";
export var tan = "bs_cr";